module.exports = __webpack_public_path__ + "media/application/images/home/essen-trinken-c83fedd5369b6c009cb9b5756d260b32.svg";